import React from 'react';

function Padlock(props: React.HTMLAttributes<SVGElement>) {
  const id = React.useId();
  const gradientId = `linear-gradient-${id}`.replace(/:/g, '');

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="30"
      fill="none"
      viewBox="0 0 24 30"
      {...props}
    >
      <rect
        width="21"
        height="17"
        x="1.5"
        y="11.5"
        fill={`url(#${gradientId})`}
        stroke="var(--color-gray-700)"
        strokeWidth="3"
        rx="2.5"
      ></rect>
      <path
        stroke="var(--color-gray-700)"
        strokeWidth="3"
        d="M6 11V7.5C6 4.462 8.686 2 12 2s6 2.462 6 5.5V11"
      ></path>
      <defs>
        <linearGradient
          id={gradientId}
          x1="24"
          x2="0"
          y1="20"
          y2="20"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="hsl(50deg 100% 80%)"></stop>
          <stop offset="0.5" stopColor="hsl(50deg 100% 70%)"></stop>
          <stop offset="1" stopColor="hsl(50deg 100% 80%)"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Padlock;
